
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jpMnG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $dehRH = parcelRequire("dehRH");

var $ihjDz = parcelRequire("ihjDz");


var $fO7zn = parcelRequire("fO7zn");


var $3rvSa = parcelRequire("3rvSa");


var $7NoXb = parcelRequire("7NoXb");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");




const $d94a223ed3433d0e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unableToLoadContent: {
        id: "fabric.editor.unableToLoadContent",
        defaultMessage: "We couldn't load this content"
    },
    failedToUpload: {
        id: "fabric.editor.failed_to_upload",
        defaultMessage: "Failed to upload"
    }
});



var $5gVJx = parcelRequire("5gVJx");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $fCrf0 = parcelRequire("fCrf0");


var $k0QVR = parcelRequire("k0QVR");


var $aWYXa = parcelRequire("aWYXa");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic




var $9hlns = parcelRequire("9hlns");

/** Height threshold that determines icon size to be small or medium */ const $6a98a0a47ebe23af$export$88e3664eef60c981 = 24;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $0090dcbf00152f3e$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    color: `${"var(--ds-text, #292A2E)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`
    }
});


const $365414ee34d9fe7e$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $0090dcbf00152f3e$export$c4d4f06a25de97f),
        "data-testid": testId
    }, children);


const $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $6a98a0a47ebe23af$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $365414ee34d9fe7e$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: height > (0, $6a98a0a47ebe23af$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};


const $c12bc8babb02df83$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $42omo.useMemo)(()=>({
            traceId: (0, $fCrf0.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    const memoizedOnImageLoad = (0, $42omo.useCallback)(()=>{
        onImageLoad(preview);
    }, [
        onImageLoad,
        preview
    ]);
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aWYXa.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnImageLoad : ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9K4OG.jsx)("script", getSsrScriptProps()));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $bSKDV = parcelRequire("bSKDV");





var $fhm10 = parcelRequire("fhm10");

function $7cf4b05323c49fee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $7cf4b05323c49fee$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $7cf4b05323c49fee$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $fhm10.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $fhm10.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $bSKDV.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $fhm10.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    const onKeyDown = (e)=>{
        if ((0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true)) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }
        return undefined;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $fhm10.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $fhm10.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $fhm10.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        role: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? 'button' : undefined,
        tabIndex: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? 0 : undefined,
        onClick: onClick,
        onKeyDown: onKeyDown,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $7cf4b05323c49fee$var$sizeWrapperStyle
    }, children)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic




var $ebrpi = parcelRequire("ebrpi");


var $3gadb = parcelRequire("3gadb");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic



function $6ea526080872ea45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6ea526080872ea45$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $6ea526080872ea45$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $6ea526080872ea45$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};


const $d55d56648ffb705b$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $365414ee34d9fe7e$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6ea526080872ea45$export$be58b4326e23250f), null, icon || /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};



const $f34f4663ccb261f9$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $42omo.useState)();
    const [subscribeError, setSubscribeError] = (0, $42omo.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $42omo.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $42omo.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $aXWIB.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $dehRH.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $dehRH.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const memoizedRenderError = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
            message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
        }), [
        formatMessage
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $d94a223ed3433d0e$export$defe85febe8b728c).failedToUpload : (0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('metadata-fetch', new (0, $fO7zn.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c12bc8babb02df83$export$bb1dd14451154199), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedRenderError : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
            ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $42omo.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $42omo.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $5gVJx.referenceHeights)['h1']),
            height: (0, $5gVJx.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $42omo.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $42omo.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $42omo.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const memoizedMediaViewerItems = (0, $42omo.useMemo)(()=>[
            identifier
        ], [
        identifier
    ]);
    const mediaViewer = (0, $42omo.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NoXb.default), {
            collectionName: identifier.collectionName || '',
            items: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedMediaViewerItems : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
            [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose,
        memoizedMediaViewerItems
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7cf4b05323c49fee$export$8519fee8cc913056), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $f34f4663ccb261f9$export$fca833ae4278270f = (0, $aXWIB.injectIntl)($f34f4663ccb261f9$export$5d2cd1bea8591ba3, {
    enforceContext: false
});
module.exports["MediaInlineImageCard"] = $f34f4663ccb261f9$export$fca833ae4278270f;

});

parcelRegister("dehRH", function(module, exports) {

var $bhuzI = parcelRequire("bhuzI");


var $ihjDz = parcelRequire("ihjDz");

const $fc1f7121f2c54ee5$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc1f7121f2c54ee5$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $bhuzI.extractErrorInfo)(error)
        }
    };
};
const $fc1f7121f2c54ee5$export$d0b5daf3b6a26055 = (fileId, fileState, processingFailReason)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing',
            // 'not-available' is used for cases before processingFailReason implementation (backward compatibility)
            processingFailReason: processingFailReason || 'not-available'
        }
    };
};
const $fc1f7121f2c54ee5$export$d66a74eca3334206 = (fileState, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    // Extract processingFailReason from fileState if available
    const processingFailReason = fileState?.status === 'failed-processing' ? fileState.failReason : undefined;
    const payload = failReason ? $fc1f7121f2c54ee5$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState, processingFailReason) : $fc1f7121f2c54ee5$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc1f7121f2c54ee5$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4(fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
module.exports["getSucceededStatusPayload"] = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4;
module.exports["getErrorStatusPayload"] = $fc1f7121f2c54ee5$export$b37f976ad373d2e0;
module.exports["getFailedProcessingStatusPayload"] = $fc1f7121f2c54ee5$export$d0b5daf3b6a26055;
module.exports["fireFailedOperationalEvent"] = $fc1f7121f2c54ee5$export$d66a74eca3334206;
module.exports["fireSucceededOperationalEvent"] = $fc1f7121f2c54ee5$export$3bc90882cb04fda4;

});

parcelRegister("i4o81", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kZmsK = parcelRequire("kZmsK");


var $bYRk6 = parcelRequire("bYRk6");




class $a406840fbc805bb1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("5R15f")),
                (parcelRequire("9DUEZ")),
                (parcelRequire("1cFiH"))
            ]);
            $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZmsK.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorBoundary, {
            isSelected: this.props.isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MediaInlineCard, this.props)));
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}
$a406840fbc805bb1$export$2e2bcd8739ae039.displayName = 'MediaInlineCardLoader';
$a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = void 0;
$a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = void 0;
module.exports["default"] = $a406840fbc805bb1$export$2e2bcd8739ae039;

});

parcelRegister("kZmsK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Dmhrr = parcelRequire("Dmhrr");


var $9hlns = parcelRequire("9hlns");


var $d3MnB = parcelRequire("d3MnB");




/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

const $8f39e15e200c8aa2$var$spinnerWrapperStyles = null;
const $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_o5721jtm _1nmz9jpi _s7n41q9y _18u0v77o"
        ])
    }, children);


const $d812b1a99afbef93$export$52b4dfd89a6b3a1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b), props);



var $9HuAe = parcelRequire("9HuAe");

class $1a4a0b48836516fc$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconTitleWrapper), null, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.RightIconPositionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d812b1a99afbef93$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 14,
            interactionName: "media-inline-card-loading-view"
        })))));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3MnB.IconAndTitleLayout), {
            title: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d812b1a99afbef93$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 14,
            interactionName: "media-inline-card-loading-view"
        }))));
    }
}
module.exports["MediaInlineCardLoadingView"] = $1a4a0b48836516fc$export$4449fcbb2ad61ad1;

});

parcelRegister("Dmhrr", function(module, exports) {

var $42omo = parcelRequire("42omo");




/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $c18bd19407527c2b$var$selectedStyles = null;
const $c18bd19407527c2b$var$notSelectedStyles = null;
const $c18bd19407527c2b$var$errorStyles = null;
const $c18bd19407527c2b$var$wrapperStyles = null; /*
                              Media Inline cards should have the following layout:
                              -----------------
                              | icon | title |
                              -----------------
                              The aim is to ensure (1) all children are
                              in line with each other, (2) are vertically
                              centered.
                            */ 
const $c18bd19407527c2b$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isSelected: isSelected, isError: isError, children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $gMc0m.default)([
            "_2rkofajl _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazi7uo _bfhki8nm _1rkwglyw _80omtlke _irr3plhp",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1j28 _80omtlke _16qsr4us _uiztglyw _4bfu1r31 _1nrm1r31 _1a3b1r31 _9oik1r31 _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhk1gly _80om73ad _irr31gly"
        ])
    }, children));


const $f4d2cc17db8a2086$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c18bd19407527c2b$export$e6dfd72ab29f8598), {
        ...props,
        ref: ref
    }));


class $81345eb3da367d71$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4d2cc17db8a2086$export$e6dfd72ab29f8598), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId
        }, children);
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}
module.exports["Frame"] = $81345eb3da367d71$export$b89a827e9254211a;

});

parcelRegister("d3MnB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6Eovk = parcelRequire("6Eovk");


var $3iiat = parcelRequire("3iiat");


var $9HuAe = parcelRequire("9HuAe");


var $1bY7o = parcelRequire("1bY7o");

class $cf4ec8e3d957b355$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.EmojiWrapper), null, emoji);
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, icon);
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Eovk.default), {
            src: url,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3iiat.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, defaultIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "currentColor",
            label: "link",
            testId: `${testId}-default`
        }));
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconTitleWrapper), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: titleColor ? {
                color: titleColor
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconPositionWrapper), null, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconEmptyWrapper), null), this.renderIcon(testId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-test-id": "title"
        }, title)));
    }
}
module.exports["IconAndTitleLayout"] = $cf4ec8e3d957b355$export$d34be4d513116847;

});

parcelRegister("3iiat", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.




var $gMc0m = parcelRequire("gMc0m");

const $5112814eaaf490cd$var$iconStyles = null;
const $5112814eaaf490cd$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ $42omo.createElement("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $gMc0m.default)([
            "_2rkolb4i _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }); // Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $5112814eaaf490cd$var$akIconWrapperStyles = null;
const $5112814eaaf490cd$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2hwx1i6y"
        ])
    }, children);


const $85360ec6e10e0eb4$export$f04a61298a47a40f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5112814eaaf490cd$export$f04a61298a47a40f), props);
const $85360ec6e10e0eb4$export$a201b065fc2e76a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5112814eaaf490cd$export$a201b065fc2e76a1), props);
module.exports["Icon"] = $85360ec6e10e0eb4$export$f04a61298a47a40f;
module.exports["AKIconWrapper"] = $85360ec6e10e0eb4$export$a201b065fc2e76a1;

});

parcelRegister("5R15f", function(module, exports) {

let $4432be3140338ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4432be3140338ead$var$load("5kvvM"),
    $4432be3140338ead$var$load("gEWAF"),
    $4432be3140338ead$var$load("8j9XC"),
    $4432be3140338ead$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9DUEZ", function(module, exports) {

let $7053b5191ecf1ff7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7053b5191ecf1ff7$var$load("7EorR"),
    $7053b5191ecf1ff7$var$load("kknf5"),
    $7053b5191ecf1ff7$var$load("hPalR"),
    $7053b5191ecf1ff7$var$load("jDjSj"),
    $7053b5191ecf1ff7$var$load("8059b"),
    $7053b5191ecf1ff7$var$load("3QZdB"),
    $7053b5191ecf1ff7$var$load("3M4Om"),
    $7053b5191ecf1ff7$var$load("4jPsO"),
    $7053b5191ecf1ff7$var$load("72780"),
    $7053b5191ecf1ff7$var$load("hszIA"),
    $7053b5191ecf1ff7$var$load("2fk6g"),
    $7053b5191ecf1ff7$var$load("ajMch"),
    $7053b5191ecf1ff7$var$load("4M7W5")
]).then(()=>parcelRequire('akEZB'));

});

parcelRegister("1cFiH", function(module, exports) {

let $0e06f2dbd2346d35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e06f2dbd2346d35$var$load("iP5Bv").then(()=>parcelRequire('lysJr'));

});

parcelRegister("9HuAe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fX8We = parcelRequire("fX8We");

const $40f11cd2f33df153$export$be58b4326e23250f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconWrapper), props);
const $40f11cd2f33df153$export$e31a6cc0a4c97f0e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.EmojiWrapper), props);
const $40f11cd2f33df153$export$c73a53738ef9e3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconTitleWrapper), props);
const $40f11cd2f33df153$export$75180efdd3f4d9c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.LozengeWrapper), props);
const $40f11cd2f33df153$export$a16269f205a2f280 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.LozengeBlockWrapper), props);
const $40f11cd2f33df153$export$91b164375b8037b5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.RightIconPositionWrapper), props);
const $40f11cd2f33df153$export$7291f9f954790243 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconPositionWrapper), props);
const $40f11cd2f33df153$export$ddce81e032b0736e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconEmptyWrapper), props);
module.exports["IconWrapper"] = $40f11cd2f33df153$export$be58b4326e23250f;
module.exports["EmojiWrapper"] = $40f11cd2f33df153$export$e31a6cc0a4c97f0e;
module.exports["IconTitleWrapper"] = $40f11cd2f33df153$export$c73a53738ef9e3f;
module.exports["RightIconPositionWrapper"] = $40f11cd2f33df153$export$91b164375b8037b5;
module.exports["IconPositionWrapper"] = $40f11cd2f33df153$export$7291f9f954790243;
module.exports["IconEmptyWrapper"] = $40f11cd2f33df153$export$ddce81e032b0736e;

});

parcelRegister("fX8We", function(module, exports) {
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $fd9b070c354e8c1f$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $fd9b070c354e8c1f$var$iconOverrideStyles = null;
const $fd9b070c354e8c1f$var$iconWrapperStyles = null; // Wraps all icons represented in Inline Links. Icons have three sources/types:
const $fd9b070c354e8c1f$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ])
    }, children);
const $fd9b070c354e8c1f$var$emojiWrapperStyles = null; // Wraps all emoji in Inline Links similar to icon
const $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconTitleWrapperStyles = null; // The main 'wrapping' element, title of the content.
const $fd9b070c354e8c1f$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_o5721jtm _1nmz9jpi"
        ])
    }, children);
const $fd9b070c354e8c1f$var$lozengeWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ])
    }, children);
const $fd9b070c354e8c1f$var$lozengeBlockWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ])
    }, children);
const $fd9b070c354e8c1f$var$rightIconPositionWrapperStyles = null;
const $fd9b070c354e8c1f$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconPositionWrapperStyles = null; // The following components are used to absolutely position icons in the vertical center.
const $fd9b070c354e8c1f$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconEmptyWrapperStyles = null;
const $fd9b070c354e8c1f$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ])
    }, children);
module.exports["IconWrapper"] = $fd9b070c354e8c1f$export$be58b4326e23250f;
module.exports["EmojiWrapper"] = $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e;
module.exports["IconTitleWrapper"] = $fd9b070c354e8c1f$export$c73a53738ef9e3f;
module.exports["LozengeWrapper"] = $fd9b070c354e8c1f$export$75180efdd3f4d9c2;
module.exports["LozengeBlockWrapper"] = $fd9b070c354e8c1f$export$a16269f205a2f280;
module.exports["RightIconPositionWrapper"] = $fd9b070c354e8c1f$export$91b164375b8037b5;
module.exports["IconPositionWrapper"] = $fd9b070c354e8c1f$export$7291f9f954790243;
module.exports["IconEmptyWrapper"] = $fd9b070c354e8c1f$export$ddce81e032b0736e;

});


//# sourceMappingURL=mediaInline.0a52cc66.js.map
